import axiosInstance from '../lib/api/axiosInstance';
import type { 
  ExchangeRatesResponse, 
  CurrencyPairsResponse, 
  ExchangeRateFilters,
  ExchangeRatesApiResponse,
  CurrencyPairsApiResponse
} from '../types/exchangeRates';

/**
 * Service pour les taux de change
 */
export class ExchangeRatesService {
  
  /**
   * Récupère les taux de change selon les filtres
   */
  static async getExchangeRates(filters: ExchangeRateFilters): Promise<ExchangeRatesResponse> {
    const params = new URLSearchParams({
      startDate: filters.startDate,
      endDate: filters.endDate,
      currencyPair: filters.currencyPair
    });

    const response = await axiosInstance.get(`/exchange-rates?${params.toString()}`);
    const raw = response.data as ExchangeRatesApiResponse;
    // Map backend shape (rates) to frontend expected (data)
    const mapped: ExchangeRatesResponse = {
      data: raw.rates || [],
      success: !raw.error,
      message: raw.message || raw.error,
      currencyPair: raw.currencyPair,
      startDate: raw.startDate,
      endDate: raw.endDate,
      totalRecords: raw.totalRecords
    };
    return mapped;
  }

  /**
   * Récupère les paires de devises disponibles
   */
  static async getAvailableCurrencyPairs(): Promise<CurrencyPairsResponse> {
    const response = await axiosInstance.get('/exchange-rates/currency-pairs');
    const raw = response.data as CurrencyPairsApiResponse;
    const mapped: CurrencyPairsResponse = {
      pairs: raw.currencyPairs || [],
      success: !raw.error,
      message: raw.message || raw.error
    };
    return mapped;
  }
}

// Export des méthodes individuelles pour faciliter l'usage
export const getExchangeRates = ExchangeRatesService.getExchangeRates;
export const getAvailableCurrencyPairs = ExchangeRatesService.getAvailableCurrencyPairs;